import * as React from 'react';
import { getGeoServerResponse } from '../apis/Apis';
import * as ol from "ol"
import { Projection } from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import { WMTS } from 'ol/source';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import * as Style from 'ol/style.js'
import * as Control from "ol/control.js";
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { Draw } from 'ol/interaction';
import { WKT } from 'ol/format';
import { unByKey } from 'ol/Observable';
import { useParams } from 'react-router-dom';
import { Alert } from '@mui/material';

export default function LegacyProcessMap({ processIDParam }) {

    const [map, setMap] = React.useState(null)
    const [error, setError] =React.useState(null)
    const { pid: pIdUrl } = useParams()
    const processId = pIdUrl ? pIdUrl : processIDParam

    var getXMLQuery = function (dem, wkt_geometry, layer_coverage) {
        var xw = new XMLWriter('UTF-8');
        xw.formatting = 'indented';//add indentation and newlines
        xw.indentChar = ' ';//indent with spaces
        xw.indentation = 2;//add 2 spaces per level

        xw.writeStartDocument();

        xw.writeStartElement('Execute', 'wps');

        xw.writeAttributeString('version', '1.0.0');
        xw.writeAttributeString('service', 'WPS');
        xw.writeAttributeString('xmlns:xsi', 'http://www.w3.org/2001/XMLSchema-instance');
        xw.writeAttributeString('xmlns', 'http://www.opengis.net/wps/1.0.0');
        xw.writeAttributeString('xmlns:wfs', 'http://www.opengis.net/wfs');
        xw.writeAttributeString('xmlns:wps', 'http://www.opengis.net/wps/1.0.0');
        xw.writeAttributeString('xmlns:ows', 'http://www.opengis.net/ows/1.1');
        xw.writeAttributeString('xmlns:gml', 'http://www.opengis.net/gml');
        xw.writeAttributeString('xmlns:ogc', 'http://www.opengis.net/ogc');
        xw.writeAttributeString('xmlns:wcs', 'http://www.opengis.net/wcs/1.1.1');
        xw.writeAttributeString('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        xw.writeAttributeString('xsi:schemaLocation', 'http://www.opengis.net/wps/1.0.0 http://schemas.opengis.net/wps/1.0.0/wpsAll.xsd');

        xw.writeElementString('ows:Identifier', 'gs:ClipAgainstNeighborhood');

        xw.writeStartElement('DataInputs', 'wps');
        xw.writeStartElement('Input', 'wps');
        xw.writeElementString('ows:Identifier', 'Raster');
        xw.writeStartElement('Reference', 'wps');
        xw.writeAttributeString('mimeType', 'image/tiff');
        xw.writeAttributeString('xlink:href', 'http://geoserver/wcs');
        xw.writeAttributeString('method', 'POST');
        xw.writeStartElement('Body', 'wps');
        xw.writeStartElement('GetCoverage', 'wcs');
        xw.writeAttributeString('service', 'WCS');
        xw.writeAttributeString('version', '1.1.1');
        xw.writeElementString('ows:Identifier', dem);
        xw.writeStartElement('DomainSubset', 'wcs');
        xw.writeStartElement('BoundingBox', 'ows');
        xw.writeAttributeString('crs', 'http://www.opengis.net/gml/srs/epsg.xml#' + layer_coverage.nativeBoundingBox.crs.$.replace("EPSG:", ""));
        xw.writeElementString('ows:LowerCorner', layer_coverage.nativeBoundingBox.minx + " " + layer_coverage.nativeBoundingBox.miny);
        xw.writeElementString('ows:UpperCorner', layer_coverage.nativeBoundingBox.maxx + " " + layer_coverage.nativeBoundingBox.maxy);
        xw.writeEndElement();
        xw.writeEndElement();
        xw.writeStartElement('wcs:Output format="image/tiff"');
        xw.writeEndElement();
        xw.writeEndElement();
        xw.writeEndElement();
        xw.writeEndElement();

        xw.writeEndElement();

        xw.writeStartElement('Input', 'wps');
        xw.writeElementString('ows:Identifier', 'ClipPolygon');
        xw.writeStartElement('Data', 'wps');
        xw.writeStartElement('ComplexData', 'wps');
        xw.writeAttributeString('mimeType', 'text/xml; subtype=gml/3.1.1');
        xw.writeCDATA(wkt_geometry);
        xw.writeEndElement();
        xw.writeEndElement();
        xw.writeEndElement();
        xw.writeEndElement();

        xw.writeStartElement('ResponseForm', 'wps');
        xw.writeStartElement('RawDataOutput', 'wps');
        xw.writeElementString('ows:Identifier', 'result');
        xw.writeEndElement();
        xw.writeEndElement();
        xw.writeEndElement();
        xw.writeEndDocument();

        var data = xw.flush(); //generate the xml string
        xw.close();//clean the writer

        return data;
    }


    const loadLegacyProcess = async () => {

        const service_name = `${processId}-ortho`
        const dem_service_name = `${processId}-dem`
        let layer_coverage =null
        try {
            const response = await getGeoServerResponse(processId)
            layer_coverage=response.coverage
        } catch (error) {
            console.log(error,"err")
            setError(error.response)
            return
        }





        var listener = null;
        var measure_type = null;
        var wkt_geometry = null;
        var tooltipCoord = null;
        var measureTooltipElement = null;
        var measureTooltip = null;
        var sketch = null;
        var draw_interaction = null;
        var select_interaction = null;

        // var getWMSLayer = function (url, layer_name, format) {
        //     var layer = new ol.layer.Image({
        //         source: new ol.source.ImageWMS({
        //             ratio: 1,
        //             url: url,
        //             params: {
        //                 FORMAT: format,
        //                 VERSION: '1.1.1',
        //                 STYLES: '',
        //                 LAYERS: 'd2b:' + layer_name
        //             }
        //         }),
        //         name: layer_name
        //     });

        //     return layer;
        // }

        var getTileWMSLayer = function (url, format, version, workspace, layer_name, projection) {

            var layer = new TileLayer({
                //opacity: 1,
                //source: getTileWMSSource(url, format, version, workspace, layer_name),
                source: getWMTSSource(url, format, version, workspace, layer_name, projection),
                //name: layer_name
            });

            return layer;
        }

        var getWMTSTilegrid = function (tile_width, tile_height, minX, minY, maxX, maxY, size) {

            var initial_resolution = (maxX - minX) / tile_width;
            var tileSize = [tile_width, tile_height];
            var extent = [minX, minY, maxX, maxY];
            var origin = [minX, maxY];
            var resolutions = new Array(size);
            var matrixIds = new Array(size);

            for (var z = 0; z < size; z++) {
                resolutions[z] = initial_resolution / Math.pow(2, z);
                matrixIds[z] = z.toString();
            }

            return new WMTSTileGrid({
                tileSize: tileSize,
                extent: extent,
                origin: origin,
                resolutions: resolutions,
                matrixIds: matrixIds
            })
        }


        var getWMTSSource = function (url, format, version, workspace, layer_name, projection) {
            return new WMTS({
                url: url,
                layer: workspace + ":" + layer_name,
                matrixSet: layer_coverage.srs.replace(':', '::'),
                format: format,
                projection: projection,
                tileGrid: getWMTSTilegrid(255, 255, -2.00375083428E7, -2.00375083428E7, 2.0037508342798717E7, 2.0037508342798717E7, 26),
                style: '',
                cacheSize: 4096,
                wrapX: true
            });
        }

        var protocol = location.protocol;
        var slashes = protocol.concat("//");
        var host = slashes.concat(window.location.hostname); //":8080"; // 8080 weg für rollout

        //var server_url = host + "/geoserver/d2b/wms";
        var server_url = window.location.origin + '/geoserver/gwc/service/wmts';

        //var base_layer = getWMSLayer(host + "/geoserver" + '/d2b/wms', service_name, 'image/jpeg');

        var bbox = layer_coverage.nativeBoundingBox;
        var epsg_code = bbox.crs.$;
        var bounds = [bbox.minx, bbox.miny, bbox.maxx, bbox.maxy];

        var projection = new Projection({
            code: epsg_code,
            canWrapX_: false,
            units: 'm',
            axisOrientation: 'neu',
            global: false
        });

        // var osm_basemap = new ol.layer.Tile({
        //     source: new ol.source.OSM({
        //         attributions: [
        //             'All maps © <a href="http://">OSM</a>',
        //             ol.source.OSM.ATTRIBUTION ],
        //         opaque: false,
        //         url: 'https://osm-prod.noncd.db.de:8100/styles/dbs-osm-basic/{z}/{x}/{y}.png?key=mcQ6mgO6oKNaxmnv4oRFXf7iazuPJAyO'
        //     })
        // });

        var base_layer = getTileWMSLayer(server_url, 'image/jpeg', '1.0.0', 'd2b', service_name, projection);

        var draw_style = new Style.Style({
            stroke: new Style.Stroke({
                color: 'red',
                width: 3
            }),
            fill: new Style.Fill({
                color: 'rgba(255, 0, 0, 0.1)'
            }),
            image: new Style.Circle({
                radius: 5,
                fill: null,
                stroke: new Style.Stroke({
                    color: "black",
                    width: 2
                })
            })
            });
        

        var vector_layer_source = new VectorSource({
            wrapX: false
        });

        var vector_layer = new VectorLayer({
            source: vector_layer_source,
            style: draw_style
        });

        var layers = [base_layer, vector_layer];
        //var layers = [osm_basemap];

        var map = new ol.Map({
            controls: Control.defaults({
                attributionOptions: {
                    collapsible: false
                }
            }),
            target: 'legagyMap',
            layers: layers,
            view: new ol.View({
                projection: projection
            })
        });

        map.getView().fit(bounds, map.getSize());


        setMap(map)

        var selected_button = $("#btn_cursor");

        var selectButton = function (button) {
            selected_button.addClass("btn-dark");
            selected_button.removeClass("btn-secondary");

            button.addClass("btn-secondary");
            button.removeClass("btn-dark");

            selected_button = button;

        }

        var messStrecke = function () {

            selectButton($("#btn_strecke"));

            map.removeInteraction(select_interaction);
            map.removeInteraction(draw_interaction);
            addInteraction('distance');
        }

        var messFlaeche = function () {

            selectButton($("#btn_flaeche"));

            map.removeInteraction(select_interaction);
            map.removeInteraction(draw_interaction);
            addInteraction('area');
        }

        var messVolume = function () {

            selected_button.addClass("btn-dark");
            selected_button.removeClass("btn-secondary");

            selected_button = $("#btn_volume");

            selected_button.addClass("btn-secondary");
            selected_button.removeClass("btn-dark");

            map.removeInteraction(select_interaction);
            map.removeInteraction(draw_interaction);
            addInteraction('volume');
        }

        var selectFeature = function () {

            selectButton($("#btn_select"));

            map.removeInteraction(select_interaction);
            map.removeInteraction(draw_interaction);

            select_interaction = new ol.interaction.Select({
                condition: ol.events.condition.click
            });

            map.addInteraction(select_interaction);
            select_interaction.on('select', function (e) {
                if (e.selected) {
                    //console.log("deleting " + e.selected);
                    //vector_layer_source.removeFeature(e.selected[0]);
                }
            });
        }

        //var home = function(){}
        //var marker = function(){}

        var clearMeasureTooltips = function () {
            map.getOverlays().clear();
            vector_layer_source.clear();
            createMeasureTooltip();
        }

        var getMoveCursor = function () {
            selectButton($("#btn_cursor"));
            removeMeasureTooltipElement();
            map.removeInteraction(draw_interaction);
        }

        var addInteraction = function (measure_type) {

            draw_interaction = new Draw({
                source: vector_layer_source,
                type: measure_type == "distance" ? "LineString" : "Polygon",
                style: draw_style
            });

            //new ol.interaction.Select();

            draw_interaction.measure_type = measure_type;

            map.addInteraction(draw_interaction);
            createMeasureTooltip();

            draw_interaction.on('drawstart', drawstart, this);
            draw_interaction.on('drawend', drawend, this);
        }

        var drawstart = function (evt) {
            sketch = evt.feature;
            listener = sketch.getGeometry().on('change', sketchGeometryChange);
        }

        var sketchGeometryChange = function (evt) {
            var geom = evt.target;

            /** type {ol.Coordinate|undefined} */
            var tooltipCoord = evt.coordinate;

            if (draw_interaction.measure_type == "area") {
                tooltipCoord = geom.getInteriorPoint().getCoordinates();
                measureTooltipElement.innerHTML = formatArea(geom);
               
                measureTooltip.setPosition(tooltipCoord);
            }
            else if (draw_interaction.measure_type == "distance") {
                tooltipCoord = geom.getLastCoordinate();
                measureTooltipElement.innerHTML = formatLength(geom);
             //   measureTooltipElement.className ="ol-tooltip-measure DBSansRegula"
                measureTooltip.setPosition(tooltipCoord);
            }
        }

        var removeMeasureTooltipElement = function () {
            if (measureTooltipElement && measureTooltipElement.parentNode) {
                measureTooltipElement.parentNode.removeChild(measureTooltipElement);
            }
        }

        var createMeasureTooltip = function () {

            removeMeasureTooltipElement();

            measureTooltipElement = document.createElement('div');
            measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure DBSansRegular';
            measureTooltip = new ol.Overlay({
                element: measureTooltipElement,
                offset: [0, -15],
                positioning: 'bottom-center'
            });
            map.addOverlay(measureTooltip);
        }

        var drawend = function () {
            var geom = sketch.getGeometry();
            wkt_geometry = new WKT().writeGeometry(geom);

            if (draw_interaction.measure_type == "volume") {
                var url = host + "/geoserver/ows?strict=true";

                var dem = 'd2b:' + dem_service_name;
                var xml = getXMLQuery(dem, wkt_geometry, layer_coverage);
                var data = $.param({ url: url, body: xml });

                var settings = {
                    async: true,
                    crossDomain: true,
                    url: host + "/geoserver/TestWfsPost",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded;"
                    },
                    data: data
                }

                $.ajax(settings).done(function (response) {

                    var parser = new DOMParser();

                    if (response instanceof XMLDocument) {
                        measureTooltipElement.innerHTML = response.getElementsByTagName("ows:ExceptionText")[0].innerHTML;
                    }
                    else {
                        var r = JSON.parse(response);
                        measureTooltipElement.innerHTML = r.vol + " m³ ref: " + r.ref_h + " m";
                    }

                    measureTooltip.setPosition(geom.getInteriorPoint().getCoordinates());
                    measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure DBSansRegular';
                    measureTooltip.setOffset([0, -7]);

                    // unset sketch
                    sketch = null;

                    // unset tooltip so that a new one can be created
                    measureTooltipElement = null;
                    createMeasureTooltip();
                    unByKey(listener);

                });

            }
            else {
                measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure DBSansRegular';
                measureTooltip.setOffset([0, -7]);

                // unset sketch
                sketch = null;

                // unset tooltip so that a new one can be created
                measureTooltipElement = null;
                createMeasureTooltip();
                unByKey(listener);
            }
        }

        var formatArea = function (polygon) {
            var area = polygon.getArea();
            var output;
            if (area > 10000) {
                output = (Math.round(area / 1000000 * 100) / 100) + ' ' + 'km²';
            } else {
                output = (Math.round(area * 100) / 100) + ' ' + 'm²';
            }
            return output;
        };

        var formatLength = function (line) {
            //var length = ol.Sphere.getLength(line);
            var length = line.getLength();
            var output;
            if (length > 1500) {
                output = (Math.round(length / 1000 * 100) / 100) + ' ' + 'km';
            } else {
                output = (Math.round(length * 100) / 100) + ' ' + 'm';
            }
            return output;
        };

        var getUrlVars = function () {
            var vars = {};
            var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                vars[key] = value;
            });
            return vars;
        }

        //$( "#btn_home" ).on( "click", home);
        $("#btn_cursor").on("click", getMoveCursor);
        //$( "#btn_marker" ).on( "click", marker);
        $("#btn_strecke").on("click", messStrecke);
        $("#btn_flaeche").on("click", messFlaeche);
        $("#btn_volume").on("click", messVolume);
        $("#btn_clear").on("click", clearMeasureTooltips);


    }


    React.useEffect(() => {
        setError(null)
        loadLegacyProcess()
    }, [])


    return (
      

            error ?  <Alert sx={{ml:"25%", pt:"25%"}} severity="error"  display="flex" justifyContent="flex-end">
             {error}
          </Alert> :
                <React.Fragment>
            <div id="legagyMap" style={{ width: "99%", height: "90%", position: "absolute" }} class="map bg-white"></div>
            <div class="overlay btn-group-vertical" role="group" style={{ position: "absolute", bottom: 0, marginBottom: "2%", marginLeft: "42%", zIndex: 1 }}>

                <button id="btn_cursor" class="btn btn-secondary btn-sm">Move</button>

                <button id="btn_strecke" class="btn btn-dark btn-sm">Strecke</button>
                <button id="btn_flaeche" class="btn btn-dark btn-sm">Fläche</button>
                {/* <button id="btn_volume" class="btn btn-dark btn-sm">Volume</button> */}
                <button id="btn_clear" class="btn btn-dark btn-sm">Clear</button>
            </div>
            </React.Fragment>
            


       
    );
}